const API_BASE = import.meta.env.VITE_API_BASE_URL;
const TOKEN_KEY = 'lorsamthai.ops.token';

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

export interface ApiError extends Error {
  status: number;
  code?: string;
  details?: unknown;
}

function toApiError(status: number, body: unknown): ApiError {
  const envelope = body as { error?: { code?: string; message?: string; details?: unknown } };
  const msg = envelope?.error?.message ?? `HTTP ${status}`;
  const err = new Error(msg) as ApiError;
  err.status = status;
  err.code = envelope?.error?.code;
  err.details = envelope?.error?.details;
  return err;
}

/**
 * Fetch wrapper that adds the Authorization header and parses JSON.
 * Throws ApiError for non-2xx responses.
 */
export async function api<T = unknown>(
  path: string,
  init: RequestInit = {}
): Promise<T> {
  const token = getToken();
  const headers = new Headers(init.headers);
  headers.set('content-type', 'application/json');
  if (token) headers.set('authorization', `Bearer ${token}`);

  const res = await fetch(`${API_BASE}${path}`, { ...init, headers });
  const text = await res.text();
  const body = text ? JSON.parse(text) : null;

  if (!res.ok) throw toApiError(res.status, body);
  return body as T;
}
